import { axios } from "@/libraries/axios";
import debounce from "lodash/debounce";
import {
	getHospitalFailure,
	getHospitalSuccess,
	getHospitals,
	getStaticContent,
	getStaticContentFailure,
	getStaticContentSuccess,
} from "../reducers/content";

async function hospitalsListener({ payload }: any, { dispatch }: any) {
	try {
		const res = await axios.get("/api/v1/hospitals", {
			params: payload,
		});
		dispatch(getHospitalSuccess(res.data));
	} catch (error) {
		dispatch(getHospitalFailure({ error: "Failed to fetch hospitals" }));
	}
}

async function staticContentListener({ payload }: any, { dispatch }: any) {
	try {
		axios.defaults.headers.common.uid = undefined;
		axios.defaults.headers.common.client = undefined;
		axios.defaults.headers.common["access-token"] = undefined;
		const res = await axios.get("/api/v1/static_contents", {
			params: {
				content_type: payload.content_type,
			},
		});
		dispatch(getStaticContentSuccess({ data: res.data }));
		payload.callback?.();
	} catch (error) {
		dispatch(
			getStaticContentFailure({ error: "Failed to fetch static Content" }),
		);
	}
}

export default function rootListener(listen: any) {
	listen(getHospitals, debounce(hospitalsListener, 100));
	listen(getStaticContent, debounce(staticContentListener, 100));
}
